const checkboxStyles = (theme, state) => {
    const { checkbox } = theme.olist.components;
    return {
        backgroundColor: checkbox['background-color'][state],
        borderColor: checkbox['border-color'][state],
        boxShadow: checkbox['box-shadow'][state],
    };
};

export { checkboxStyles };
